import { render, staticRenderFns } from "./SurveyQuestions.vue?vue&type=template&id=b371c32a&scoped=true"
import script from "./SurveyQuestions.vue?vue&type=script&lang=ts"
export * from "./SurveyQuestions.vue?vue&type=script&lang=ts"
import style0 from "./SurveyQuestions.vue?vue&type=style&index=0&id=b371c32a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b371c32a",
  null
  
)

export default component.exports